import L from 'leaflet';

/** Static map UI — optional zip boundaries from localStorage (no fetch). */
export function loadZipcodeMapCache() {
  try {
    const raw = localStorage.getItem('zipcode_map_cache');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.geoJson?.features?.length) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function getGeoJsonLatLngBounds(geoJson) {
  if (!geoJson?.features?.length) return null;
  try {
    const bounds = L.geoJSON(geoJson).getBounds();
    return bounds.isValid() ? bounds : null;
  } catch {
    return null;
  }
}
